import { useState } from 'react';
import { Box, Container, Snackbar, Alert } from '@mui/material';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import HowItWorks from '../components/HowItWorks';
import Footer from '../components/Footer';
import { useEmailSubscription } from '../hooks/useEmailSubscription';

function Home() {
  const [email, setEmail] = useState('');
  const { loading, snackbar, setSnackbar, subscribeEmail } = useEmailSubscription();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await subscribeEmail(email, () => {
      setEmail('');
    });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #fafaf8 0%, #f5f5f0 100%)',
        position: 'relative',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <Navbar />
      <Container 
        maxWidth="md" 
        sx={{ 
          position: 'relative', 
          zIndex: 1,
          px: { xs: 0, sm: 0, md: 0 },
        }}
      >
        <Box
          sx={{
            // Navbar is fixed; add top padding so it doesn't cover the hero/logo
            pt: { xs: 17, sm: 20, md: 23 },
            pb: { xs: 4, sm: 6, md: 8 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '100vh',
            justifyContent: 'space-between',
          }}
        >
          <HeroSection
            email={email}
            setEmail={setEmail}
            loading={loading}
            onSubmit={handleSubmit}
          />

          <HowItWorks />
        </Box>
      </Container>

      <Footer />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{
          bottom: { xs: 16, sm: 24 },
        }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ 
            width: { xs: 'calc(100% - 32px)', sm: 'auto' },
            maxWidth: { xs: 'calc(100vw - 32px)', sm: '400px' },
            fontSize: { xs: '0.9rem', sm: '1rem' },
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Home;
